import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/menu/vti.svg'
import _imports_1 from '@/assets/svg/menu/telephone.svg'
import _imports_2 from '@/assets/svg/menu/location.svg'
import _imports_3 from '@/assets/svg/menu/lk.svg'
import _imports_4 from '@/assets/svg/menu/tg.svg'
import _imports_5 from '@/assets/svg/menu/vk.svg'
import _imports_6 from '@/assets/svg/menu/menu.svg'


const _hoisted_1 = { class: "menu-wrapper" }
const _hoisted_2 = { class: "menu-content mx-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.vti-service.ru/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-wrapper",
    src: _imports_0
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon mx-2",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text",
    href: "tel:+74712400770"
  }, "8 (4712) 400-770 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-l" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex",
      role: "button"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "icon mx-2",
        src: _imports_2
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-start" }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "text",
          href: "https://yandex.ru/maps/org/vti_servis/1210119352/?ll=36.187930%2C51.739176&z=17.89",
          target: "_blank"
        }, "г. Курск, ул. Ватутина, д. 25"),
        /*#__PURE__*/_createElementVNode("div", { class: "text" }, "с 9-00 до 18-00")
      ])
    ])
  ])
], -1)
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "container-m-l" }
const _hoisted_8 = {
  class: "d-flex",
  role: "button"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon mx-2",
  src: _imports_3
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex\"><div class=\"container-l\"><div class=\"d-flex\"><a href=\"https://t.me/vtiservicekursk\" target=\"_blank\"><img class=\"icon mx-2\" src=\"" + _imports_4 + "\"></a><a href=\"https://vk.com/vti.service\" target=\"_blank\"><img class=\"icon mx-2\" src=\"" + _imports_5 + "\"></a></div></div></div>", 1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationBox = _resolveComponent("NavigationBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", {
                class: "text",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openLK && _ctx.openLK(...args)))
              }, "Личный кабинет ")
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", {
          class: "d-flex",
          role: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNavigationBox = !_ctx.showNavigationBox))
        }, _hoisted_12)
      ])
    ]),
    _createVNode(_component_NavigationBox, {
      modelValue: _ctx.showNavigationBox,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showNavigationBox) = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}